import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#a05a2c',
        secondary: '#784421',
        tertiary: '#0088aa',
        accent: '#ffcc00',
        error: '#EF5350',
        warning: '#FFAB40',
        info: '#4DB6AC',
        success: '#00C853',
        uniformtableheader: '#44cb82',
        uniformchipinfo: '#4EA9D0'
      }
    }
  }
});
